import React, { Component } from "react";
import "../Styles/ClassesStyles.css";
import SpinClass from "../Images/Class1.jpg";
import SpinClassGroup from "../Images/Class5.jpg";

export class Classes extends Component {
  displayName = this.name;

  render() {
    var ClassNames = [
      [
        "Bootcamp",
        "This dynamic class will get your heart pumping using cardio drills, plyometrics and calisthenics to build strength and reduce body fat. Prepare to sweat! Intermediate to advanced levels.",
      ],
      [
        "Cardio Sculpt",
        "This high intensity, high energy class uses weighted and body weight exercises to strengthen and tone muscles while building endurance. Intermediate to advanced fitness levels.",
      ],

      [
        "Spin",
        "Burn massive amounts of calories in this exciting and fun, low impact indoor cycling class. Your instructor will lead you through challenging terrain, climbing hills, sprinting flats and riding down bumpy roads. You control your speed and resistance, making this class great for all fitness levels.",
      ],
      [
        "Aqua Fit",
        "Uses the resistance and buoyancy of the water to provide a cardio and muscular challenge. Great for all fitness levels from the beginner to the elite athlete.",
      ],
      [
        "Pilates",
        "This class will help you develop a strong core and improve coordination, posture and balance. Focuses on exercises that help stabilize the spine and pelvis, but also provides full body toning. All fitness levels.",
      ],
    ];

    var classes = [];
    ClassNames.forEach((value) => {
      classes.push(
        <p>
          <i style={{ color: "white" }}>{value[0]}</i> - {value[1]}
        </p>
      );
    });

    return (
      <div>
        <div className="container">
          <div className="row" style={{ marginTop: "30px" }}>
            <div className="col-md-6">
              <h1>Find The Right Class For You!</h1>
              <p>
                Our certified instructors are happy to help you work at the
                appropriate level for you. Just let him or her know if you need
                to take it easy or ramp it up! They are here to help you reach
                your fitness goals. While most of our classes can be modified to
                fit any fitness level, some were designed with a specific
                population in mind. Please see the following guidliness and ask
                at the front desk for a more detailed description of our
                classes.
              </p>
            </div>
            <div className="col-md-6">
              <img src={SpinClass} alt="Spin Class" style={{ width: "100%" }} />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <table className="class-table" style={{ marginTop: "15px" }}>
                <tbody>
                  <tr>
                    <th></th>
                    <th>Monday</th>
                    <th>Tuesday</th>
                    <th>Wednesday</th>
                  </tr>
                  <tr>
                    <td>5:15</td>
                    <td>Boot Camp</td>
                    <td>Spin</td>
                    <td>Boot Camp</td>
                  </tr>
                  <tr>
                    <td>8:30</td>
                    <td>Spin</td>
                    <td></td>
                    <td>Boot Camp</td>
                  </tr>
                  <tr>
                    <td>8:45</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>9:15</td>
                    <td>
                      Senior Fit & Tone
                      <br />
                      Buns & Guns
                    </td>
                    <td>Abs/Hiit Class</td>
                    <td>
                      Senior Fit & Tone
                      <br />
                      Buns & Guns
                    </td>
                  </tr>
                  <tr>
                    <td>9:45</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>10:15</td>
                    <td>Aqua Fit</td>
                    <td>Aqua Fit</td>
                    <td>Aqua Fit</td>
                  </tr>
                  <tr>
                    <td>10:30</td>
                    <td>Pilates</td>
                    <td></td>
                    <td>Pilates</td>
                  </tr>
                  <tr>
                    <td>4:15</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>5:15</td>
                    <td>Bootcamp</td>
                    <td>
                      Kettle Bell <br /> Spin
                    </td>
                    <td>Boot Camp</td>
                  </tr>
                  <tr>
                    <td>6:00</td>
                    <td></td>
                    <td>Aqua Fit</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col-md-6">
              <table className="class-table" style={{ marginTop: "15px" }}>
                <tbody>
                  <tr>
                    <th></th>
                    <th>Thursday</th>
                    <th>Friday</th>
                    <th>Saturday</th>
                  </tr>
                  <tr>
                    <td>5:15</td>
                    <td>Spin</td>
                    <td>Boot Camp</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>8:30</td>
                    <td></td>
                    <td></td>
                    <td>Spin</td>
                  </tr>
                  <tr>
                    <td>8:45</td>
                    <td></td>
                    <td></td>
                    <td>Cardio Sculpt</td>
                  </tr>
                  <tr>
                    <td>9:15</td>
                    <td>Abs/Hiit Class</td>
                    <td>
                      <br />
                      <br />
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>9:45</td>
                    <td></td>
                    <td></td>
                    <td>Kick Boxing</td>
                  </tr>
                  <tr>
                    <td>10:15</td>
                    <td>Aqua Fit</td>
                    <td>Aqua Fit</td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>10:30</td>
                    <td></td>
                    <td>Pilates</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>4:15</td>
                    <td></td>
                    <td>Bootcamp</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>5:15</td>
                    <td>
                      Kettle Bell <br /> Spin
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>6:00</td>
                    <td>Aqua Fit</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <h2 style={{ textAlign: "center" }}>About Our Classes</h2>
            <ul>{classes}</ul>
            <p style={{ textAlign: "center", fontStyle: "italic" }}>
              Call for more information about a class!
            </p>
          </div>
          <div className="row" style={{ textAlign: "center" }}>
            <img
              src={SpinClassGroup}
              alt="Swim Class"
              style={{ width: "100%", padding: "30px" }}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Classes.jsx